import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

export const DialogYesNo = ({
  open,
  onClose,
  onConfirm,
  onReject,
  title,
  prompt,
  textYes = 'Yes',
  textNo = 'No',
  textCancel = 'Cancel',
  id,
}) => {
  const handleConfirm = () => {
    onClose()
    onConfirm()
  }

  const handleReject = () => {
    onClose()
    onReject()
  }
  return (
    <Dialog maxWidth='sm' open={open} onClose={onClose}>
      <DialogTitle {...{ id }}>{title}</DialogTitle>
      <DialogContent dividers>
        <Typography>{prompt}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          {textCancel}
        </Button>
        {onReject && (
          <Button variant='outlined' onClick={handleReject}>
            {textNo}
          </Button>
        )}
        <Button variant='contained' color='primary' onClick={handleConfirm}>
          {textYes}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
